var map = {
	"./Architecture/2Z7A3908.jpg": 6991,
	"./Architecture/2Z7A3933.jpg": 813,
	"./Architecture/2Z7A3942.jpg": 1121,
	"./Architecture/2Z7A3946.jpg": 8381,
	"./Creative/2Z7A4502.jpg": 6234,
	"./Creative/birthday_cake.jpg": 8799,
	"./Creative/colongue.jpg": 1863,
	"./Nature/2Z7A1330.jpg": 8402,
	"./Nature/2Z7A1496.jpg": 7429,
	"./Nature/2Z7A1506.jpg": 1303,
	"./Nature/2Z7A1520.jpg": 3207,
	"./Nature/2Z7A4131.jpg": 2966,
	"./Nature/2Z7A4168.jpg": 4144,
	"./Nature/2Z7A4245.jpg": 6692,
	"./Nature/2Z7A4386.jpg": 2546,
	"./Nature/2Z7A4428.jpg": 3209,
	"./Nature/forest_1.jpg": 7824,
	"./Nature/forest_2.jpg": 2175,
	"./Nature/grass.jpg": 3465,
	"./Portraits/2Z7A1388_1.jpg": 8016,
	"./Portraits/2Z7A3967.jpg": 3417,
	"./Portraits/nethan1.jpg": 8021,
	"./Wildlife/2Z7A1687.jpg": 3452,
	"./Wildlife/2Z7A4284-2.jpg": 8553,
	"./Wildlife/duck.jpg": 8897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9443;